export const enum UserAccess {
    INVALID = -1,
    GUEST = 0,
    MEMBER_BASIC = 1,
    MEMBER_PREMIUM = 2,
    MODEL = 4,
    MEMBER_ADMIN = 5,
}

export enum UserAccountStatus {
    guest = 'guest',
    basic = 'basic',
    premium = 'premium',
    platinum_premium = 'platinum_premium',
    model = 'model',
    admin = 'admin',
}

export const isLevelAdmin = (level: UserAccess) =>
    level === UserAccess.MEMBER_ADMIN
export const isLevelModel = (level: UserAccess) => level === UserAccess.MODEL
export const isLevelPremium = (level: UserAccess) =>
    level === UserAccess.MEMBER_PREMIUM
export const isLevelBasic = (level: UserAccess) =>
    level === UserAccess.MEMBER_BASIC
export const isLevelGuest = (level: UserAccess) => level === UserAccess.GUEST

export const isLevelBasicOrHigher = (level: UserAccess) =>
    level >= UserAccess.MEMBER_BASIC
export const isLevelPremiumOrHigher = (level: UserAccess) =>
    level >= UserAccess.MEMBER_PREMIUM
export const isLevelModelOrHigher = (level: UserAccess) =>
    level >= UserAccess.MODEL

export const isLevelInvalid = (level: UserAccess) =>
    level === UserAccess.INVALID
export const isLevelMember = (level: UserAccess) =>
    !isLevelModel(level) && !isLevelInvalid(level)

export const isInvalidUser = (name: string, level: UserAccess) =>
    !name || isLevelInvalid(level)
